"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createWorkflowsEpic = exports.fetchWorkflowsExistenceEpic = void 0;

var _reduxObservable = require("redux-observable");

var _actions = require("settings-ui-sdk/QuoteApproval/actions");

var _selectors = require("settings-ui-sdk/QuoteApproval/selectors");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("settings-ui-sdk/QuoteApproval/API"));

var fetchWorkflowsExistenceEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.fetchWorkflowsExistence,
  initiatingActionType: _actions.QuoteApprovalActionTypes.FETCH_WORKFLOWS_EXISTENCE,
  requestActions: _actions.FetchWorkflowsExistence,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: _selectors.getWorkflowsExistenceFetchStatus
}));
exports.fetchWorkflowsExistenceEpic = fetchWorkflowsExistenceEpic;
var createWorkflowsEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createWorkflows,
  initiatingActionType: _actions.QuoteApprovalActionTypes.CREATE_WORKFLOWS,
  requestActions: _actions.CreateWorkflows,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED, _RequestStatusTypes.default.SUCCEEDED],
  requestStatusSelector: _selectors.getWorkflowsCreateStatus
}));
exports.createWorkflowsEpic = createWorkflowsEpic;

var _default = (0, _reduxObservable.combineEpics)(fetchWorkflowsExistenceEpic, createWorkflowsEpic);

exports.default = _default;